import { Icon, type IconName } from "../components/Icon";
import { useSystemStatus } from "../system/SystemStatusContext";

interface TaskbarItem {
  icon: IconName;
  label: string;
  value: string;
  tone?: "info" | "accent" | "warn" | "danger";
  hint?: string;
}

function fmt(n: number): string {
  return n.toLocaleString("es-CL");
}

export function Taskbar(): JSX.Element {
  const status = useSystemStatus();

  const items: TaskbarItem[] = [
    {
      icon: "server",
      label: "API",
      value: status.apiOnline ? "online" : "offline",
      tone: status.apiOnline ? "accent" : "danger",
      hint: status.apiOnline ? "FastAPI responde 200 en /health" : "sin contacto",
    },
    {
      icon: "wifi",
      label: "Ingesta",
      value: `${fmt(Math.round(status.ingestaPerHour))} lecturas/h`,
      tone: status.ingestaPerHour > 1_000_000 ? "accent" : "warn",
      hint: "objetivo R11.2 ≥ 1M lecturas/h",
    },
    {
      icon: "bell",
      label: "Alertas abiertas",
      value: String(status.alertasAbiertas),
      tone: status.alertasAbiertas > 30 ? "warn" : "info",
    },
    {
      icon: "shield",
      label: "Órdenes fuera de SLA",
      value: String(status.ordenesFueraSla),
      tone: status.ordenesFueraSla === 0 ? "accent" : "danger",
    },
    {
      icon: "droplet",
      label: "NRW vigente",
      value: status.nrwUltimoPeriodo,
      tone: "info",
      hint: "último snapshot oficial",
    },
  ];

  const formattedTime = status.lastUpdated.toLocaleTimeString("es-CL", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return (
    <footer className="app-taskbar" role="contentinfo">
      <div className="app-taskbar__items">
        {items.map((item) => (
          <div
            key={item.label}
            className={`app-taskbar__item app-taskbar__item--${item.tone ?? "info"}`}
            title={item.hint}
          >
            <span className="app-taskbar__icon">
              <Icon name={item.icon} size={14} />
            </span>
            <span className="app-taskbar__label">{item.label}</span>
            <span className="app-taskbar__value">{item.value}</span>
          </div>
        ))}
      </div>
      <div className="app-taskbar__clock">
        <Icon name="clock" size={14} />
        <span>{formattedTime}</span>
      </div>
    </footer>
  );
}
